/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshSavingsAppletRequest} from '@cash-web/protos/squareup/cash/app/refresh_savings_applet.pb'
import {RefreshSavingsAppletResponse} from '@cash-web/protos/squareup/cash/app/refresh_savings_applet.pb'


export const refreshSavingsApplet = (request: RefreshSavingsAppletRequest, options?: CashRequestOptions) => post<RefreshSavingsAppletRequest, RefreshSavingsAppletResponse>("/2.0/cash/refresh-savings-applet", request, {...options, rejectOnError: true })